/* eslint-disable no-constant-condition */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { useFormikContext } from "formik";
import Input from "components/lib/Shared/Input";

const NamesForm = ({
    field,
    form,
    disableForm,
    formStepErrors = {},
    disableVerificationField,
    disableDateOfRegistration,
    ...props
}) => {
    const { setFieldValue, values } = useFormikContext();

    const handleSetValue = (e) => {
        setFieldValue(field.name, {
            ...field.value,
            [e.target.name]: e.target.value,
        });
    };

    return (
        <>
            <div className=" grid grid-cols-6 gap-6 mt-3" >
                <div className="col-span-6 sm:col-span-2">
                    <Input
                        label="First Name"
                        name="firstName"
                        placeholder="Enter first name"
                        form={form}
                        errorPath="names.firstName"
                        value={field.value?.firstName ?? ""}
                        onBlur={field.onBlur}
                        disabled={disableForm}
                        onChange={handleSetValue}
                    />
                    {formStepErrors.names?.firstName && (
                        <small className="text-red-500 mt-2 py-4 px-1 font-semibold">
                            {formStepErrors.names?.firstName}
                        </small>
                    )}
                </div>
                <div className="col-span-6 sm:col-span-2">
                    <Input
                        label="Middle Name"
                        name="middleName"
                        placeholder="Enter middle name"
                        form={form}
                        value={field.value?.middleName ?? ""}
                        disabled={disableForm}
                        onBlur={field.onBlur}
                        onChange={handleSetValue}
                        errorPath="names.middleName"
                    />
                </div>
                <div className="col-span-6 sm:col-span-2">
                    <Input
                        label="Last Name"
                        name="lastName"
                        placeholder="Enter last name"
                        form={form}
                        value={field.value?.lastName ?? ""}
                        disabled={disableForm}
                        errorPath="names.lastName"
                        onBlur={field.onBlur}
                        onChange={handleSetValue}
                    />
                    {formStepErrors.names?.lastName && (
                        <small className="text-red-500 mt-2 py-4 px-1 font-semibold">
                            {formStepErrors.names?.lastName}
                        </small>
                    )}
                </div>
                <div className="col-span-6 sm:col-span-2">
                    <Input
                        label="Former Name (IF ANY)"
                        name="formerName"
                        placeholder="Enter former name"
                        form={form}
                        value={field.value?.formerName ?? ""}
                        disabled={disableForm}
                        errorPath="names.formerName"
                        onBlur={field.onBlur}
                        onChange={handleSetValue}
                    />
                </div>
            </div>
            <div className="grid grid-cols-6 gap-6">
                {values.idType === "Kenyan Citizen" && (
                    <div className="col-span-6 sm:col-span-3 lg:col-span-2 mt-4">
                        <Input
                            label="National ID Number"
                            name="nationalIDNumber"
                            placeholder="Enter national ID number"
                            form={form}
                            value={values.nationalIDNumber ?? ""}
                            onBlur={field.onBlur}
                            disabled={true}
                        />
                    </div>
                )}
                {values.idType === "Foreign Resident" && (
                    <div className="col-span-6 sm:col-span-3 lg:col-span-2 mt-4">
                        <Input
                            label="Foreign Certificate ID"
                            name="foreignCertificateID"
                            placeholder="Enter foreign certificate ID"
                            form={form}
                            value={values.foreignCertificateID ?? ""}
                            disabled={true}
                            onBlur={field.onBlur}
                        />
                    </div>
                )}
                {values.idType === "Foreigner" && (
                    <div className="col-span-6 sm:col-span-3 lg:col-span-2 mt-4">
                        <Input
                            label="Passport Number"
                            name="passportNumber"
                            placeholder="Enter passport number"
                            form={form}
                            value={values.passportNumber ?? ""}
                            disabled={true}
                            onBlur={field.onBlur}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default NamesForm;
